import { render, staticRenderFns } from "./ModalNotification.vue?vue&type=template&id=239baf8c&scoped=true"
import script from "./ModalNotification.vue?vue&type=script&lang=js"
export * from "./ModalNotification.vue?vue&type=script&lang=js"
import style0 from "./ModalNotification.vue?vue&type=style&index=0&id=239baf8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239baf8c",
  null
  
)

export default component.exports